import { render, staticRenderFns } from "./market_loader.vue?vue&type=template&id=4bc78fdb&scoped=true&"
import script from "./market_loader.vue?vue&type=script&lang=js&"
export * from "./market_loader.vue?vue&type=script&lang=js&"
import style0 from "./market_loader.vue?vue&type=style&index=0&id=4bc78fdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc78fdb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
